import React from 'react'
import reactStamp from 'react-stamp'
import Group from './Group'
import RaisedButton from 'material-ui/RaisedButton';
import './health.css'

export default reactStamp(React).compose({

    render() {
        return (
            <div className="health-container">
                <h1 className="title">Medical History</h1>
                <p className="description">
                    Please answer the following questions as completely and accurately as you can.
                    Only your Anypoint Clinic Team will have access to this information unless you decide to share it
                    with your family
                    or other health care professionals.
                </p>
                <Group
                    title="Medical Condition"
                    description="Please add any other significant medical conditions (if any)"
                    type="condition"
                    data={this.props.conditions}
                    handleNameChange={this.props.handleNameChange}
                    handleDateChange={this.props.handleDateChange}
                    createNew={this.props.createNew}
                    removeGroupItem={this.props.removeGroupItem}
                    editMode={this.props.editMode}
                />
                <Group
                    title="Allergies"
                    description="Please add any significant allergies to medications, foods and other substances"
                    type="allergy"
                    data={this.props.allergies}
                    handleNameChange={this.props.handleNameChange}
                    handleDateChange={this.props.handleDateChange}
                    createNew={this.props.createNew}
                    removeGroupItem={this.props.removeGroupItem}
                    editMode={this.props.editMode}
                />
                {this.getActions(this.props.editMode)}
            </div>
        )
    },

    getActions(editMode){
        
        const styles = {
            button: {
                height: 50,
                width: 220,
                marginRight: 10,
                marginLeft: 10,
            }
        };

        if (editMode) {
            return (
                <div className="health-footer-actions">
                    <RaisedButton
                        label="Cancel"
                        style={styles.button}
                        onTouchTap={this.props.handleDiscardChanges}
                    />
                    <RaisedButton
                        label="Save changes"
                        primary={true}
                        style={styles.button}
                        onTouchTap={this.props.handleSaveChanges}
                    />
                </div>
            )
        }else {
            return (
                <div className="health-footer-actions">
                    <RaisedButton
                        label="Add"
                        style={styles.button}
                        onTouchTap={this.props.editChanges}
                    />
                </div>
            )
        }
    }

});



/** WEBPACK FOOTER **
 ** ./src/app/components/Health/index.js
 **/